/* tslint:disable */

export const faRectangleLandscape: any = {"prefix":"fas","iconName":"rectangle-landscape","icon":[512,512,[],"f2fa","M464 448H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48z"]};